export default __webpack_public_path__ + "static/kaykay-8a00c1d438b5ab617185c3c4fed3f5a2.png";